'use es6';

import { useLayoutEffect } from 'react';
const HubspotSoftwareNavHider = () => {
  useLayoutEffect(() => {
    let styleEl = document.getElementById('hs-nav-hide-style');
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'hs-nav-hide-style';
      document.getElementsByTagName('head')[0].appendChild(styleEl);
      styleEl.innerHTML = '#hs-nav-v4 { display: none; }';
    }
    return () => {
      if (styleEl.parentElement) {
        styleEl.parentElement.removeChild(styleEl);
      }
    };
  }, []);
  return null;
};
export default HubspotSoftwareNavHider;